import React from 'react';
import reportLogo from '../assets/images/reportLogo.png';
import '../styles/MedicalReport.scss';

// Reusable Report Title Component
export const ReportTitle = ({ title, className = '' }) => (
  <h1
    className={`medical-report-override ${className}`}
    style={{
      fontWeight: 'bold !important',
      textTransform: 'uppercase !important',
      color: 'black !important',
      margin: '0 !important',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important"
    }}>
    {title}
  </h1>
);

// MedicalReportTemplate - Reusable component for medical reports
const MedicalReportTemplate = ({
  title = 'MEDICAL REPORT',
  clinicName = "ASCAS FERTILITY AND WOMEN'S CENTRE",
  clinicContact = {
    phone: '+91-9342521779',
    email: 'accumedspecialityclinic@gmail.com',
    website: 'www.ascasclinic.com'
  },
  clinicLogo = null, // Path to logo image
  patientData = {},
  sections = [],
  impression = '',
  comments='',
  referenceValues = [],
  footerText = '',
  maxWidth = '250mm'
}) => {
  // Debug logging
  console.log('MedicalReportTemplate received props:', {title, patientData, sections, impression});

  // Default patient data structure
  const defaultPatientData = {
    uhid: '',
    patientOneName: '',
    patientTwoName: '',
    genderOne:'',
    genderTwo:'',
    patientOneAge: '',
    patientTwoAge: '',
    date: '',
    doctor: '',
    modeOfCollection: '',
    timeOfExamination: '',
    spillage: '',
    sampleCollection: '',
    timeOfCollection:'',
    sampleCollectionDate: '',
    abstinencePeriod: '',
    androtechName: '',
    consultantName: '',
    ...patientData
  };

  console.log(`patientData -->`,patientData);

  console.log('Processed defaultPatientData:', defaultPatientData);

  return (
    <div className="medical-report-container">
      <div className="medical-report-a4-container">
        {/* Header Section */}
        <div className="medical-report-header">
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '8px'}}>
            <img src={reportLogo} alt={`${clinicName} Logo`} className="medical-report-logo" />
          </div>
          <h1 className="medical-report-clinic-name">
            {clinicName}
          </h1>
          <div className="medical-report-contact-info">
            <div className="medical-report-contact-item">
              <span>📞</span>
              <span>{clinicContact.phone}</span>
            </div>
            <div className="medical-report-contact-item">
              <span>✉️</span>
              <span>{clinicContact.email}</span>
            </div>
            <div className="medical-report-contact-item">
              <span>🌐</span>
              <span>{clinicContact.website}</span>
            </div>
          </div>
        </div>

        {/* Report Title */}
        <div className="medical-report-title-container">
          <h2 className="medical-report-title">
            {title}
          </h2>
        </div>

        {/* Patient Information - Two Column Layout */}
        <div className="medical-report-patient-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
          <div className="medical-report-patient-column">
            {defaultPatientData.patientOneId && (
              <div className="medical-report-patient-row">
                <span className="medical-report-patient-label">Patient ID</span>
                <span className="medical-report-patient-value">: {defaultPatientData.patientOneId}</span>
              </div>
            )}
            {defaultPatientData.patientOneName && (
              <div className="medical-report-patient-row">
                <span className="medical-report-patient-label">Male Partner Name</span>
                <span className="medical-report-patient-value">: {defaultPatientData.patientOneName}</span>
              </div>
            )}
            {defaultPatientData.genderOne && (
              <div className="medical-report-patient-row">
                <span className="medical-report-patient-label">Gender</span>
                <span className="medical-report-patient-value">: {defaultPatientData.genderOne}</span>
              </div>
            )}
            {defaultPatientData.patientOneAge !== undefined && defaultPatientData.patientOneAge !== null && (
              <div className="medical-report-patient-row">
                <span className="medical-report-patient-label">Patient Age</span>
                <span className="medical-report-patient-value">: {defaultPatientData.patientOneAge}</span>
              </div>
            )}
            
          </div>
          <div className="medical-report-patient-column">
            
          {defaultPatientData.patientTwoId && (
              <div className="medical-report-patient-row">
                <span className="medical-report-patient-label">Patient ID</span>
                <span className="medical-report-patient-value">: {defaultPatientData.patientTwoId}</span>
              </div>
            )}
            {defaultPatientData.patientTwoName && (
              <div className="medical-report-patient-row">
                <span className="medical-report-patient-label">Female Partner Name</span>
                <span className="medical-report-patient-value">: {defaultPatientData.patientTwoName}</span>
              </div>
            )}
            {defaultPatientData.genderTwo && (
              <div className="medical-report-patient-row">
                <span className="medical-report-patient-label">Gender</span>
                <span className="medical-report-patient-value">: {defaultPatientData.genderTwo}</span>
              </div>
            )}
            {defaultPatientData.patientTwoAge !== undefined && defaultPatientData.patientTwoAge !== null  && (
              <div className="medical-report-patient-row">
                <span className="medical-report-patient-label">Patient Age</span>
                <span className="medical-report-patient-value">: {defaultPatientData.patientTwoAge}</span>
              </div>
            )}
          </div>
        </div>

        {/* Dynamic Sections */}
        {sections.map((section, index) => (
          <div key={index} className={section.noWrapper ? "" : "medical-report-section"} style={section.noWrapper ? { marginBottom: '0.75rem' } : {}}>
            {section.title && (
              <div className="medical-report-section-header">
                <h3 className="medical-report-section-title">
                  {section.title}
                </h3>
              </div>
            )}
            <div className={section.noWrapper ? "" : "medical-report-section-content"}>
              {section.layout === 'grid-2' ? (
                <table className="medical-report-table">
                  <tbody>
                    {/* Group items into rows of 3 (6 columns total) */}
                    {section.data && Array.isArray(section.data) && Array.from({ length: Math.ceil(section.data.length / 3) }, (_, rowIndex) => (
                      <tr key={rowIndex} className="medical-report-table-row">
                        {/* Each row has 3 label-value pairs (6 columns) */}
                        {[0, 1, 2].map(colIndex => {
                          const itemIndex = rowIndex * 3 + colIndex;
                          const item = section.data[itemIndex];
                          return item ? (
                            <React.Fragment key={colIndex}>
                              <td className="medical-report-table-cell font-semibold">
                                {item.label}
                              </td>
                              <td className="medical-report-table-cell">
                                : {item.value}
                              </td>
                            </React.Fragment>
                          ) : (
                            <React.Fragment key={colIndex}>
                              <td className="medical-report-table-cell"></td>
                              <td className="medical-report-table-cell"></td>
                            </React.Fragment>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : section.layout === 'custom-grid' ? (
                <div style={{display: 'flex', gap: '40px'}}>
                  {/* Left Column - First set of items */}
                  <div style={{flex: 1}}>
                    <table className="medical-report-table">
                      <tbody>
                        {section.data && Array.isArray(section.data) && section.data[0] && Array.isArray(section.data[0]) && section.data[0].map((item, index) => (
                          <tr key={index} className="medical-report-table-row">
                            <td className="medical-report-table-cell font-semibold" style={{width: '60%'}}>
                              {item.label}
                            </td>
                            <td className="medical-report-table-cell" style={{width: '40%'}}>
                              : {item.value}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* Right Column - Second set of items */}
                  <div style={{flex: 1}}>
                    <table className="medical-report-table">
                      <tbody>
                        {section.data && Array.isArray(section.data) && section.data[1] && Array.isArray(section.data[1]) && section.data[1].map((item, index) => (
                          <tr key={index} className="medical-report-table-row">
                            <td className="medical-report-table-cell font-semibold" style={{width: '60%'}}>
                              {item.label}
                            </td>
                            <td className="medical-report-table-cell" style={{width: '40%'}}>
                              : {item.value}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : section.layout === 'two-column' ? (
                <table className="medical-report-table two-column-table">
                  <colgroup>
                    <col style={{width: '20%'}} />
                    <col style={{width: '30%'}} />
                    <col style={{width: '20%'}} />
                    <col style={{width: '30%'}} />
                  </colgroup>
                  <tbody>
                    {/* Group items into rows of 2 (4 columns total) */}
                    {section.data && Array.isArray(section.data) && Array.from({ length: Math.ceil(section.data.length / 2) }, (_, rowIndex) => (
                      <tr key={rowIndex} className="medical-report-table-row">
                        {/* Each row has 2 label-value pairs (4 columns) */}
                        {[0, 1].map(colIndex => {
                          const itemIndex = rowIndex * 2 + colIndex;
                          const item = section.data[itemIndex];
                          return item ? (
                            <React.Fragment key={colIndex}>
                              <td className="medical-report-table-cell font-semibold">
                                {item.label}
                              </td>
                              <td className="medical-report-table-cell">
                                : {item.value}
                              </td>
                            </React.Fragment>
                          ) : (
                            <React.Fragment key={colIndex}>
                              <td className="medical-report-table-cell"></td>
                              <td className="medical-report-table-cell"></td>
                            </React.Fragment>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : section.layout === 'full-table' ? (
                <table className="medical-report-table-full">
                  {section.headers && (
                    <thead>
                      <tr>
                        {section.headers.map((header, hIdx) => (
                          <th key={hIdx}>{header}</th>
                        ))}
                      </tr>
                    </thead>
                  )}
                  <tbody>
                    {section.data && Array.isArray(section.data) && section.data.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {row && Array.isArray(row) && row.map((cell, cellIndex) => (
                          <td key={cellIndex} style={cell.style || {}}>
                            {cell.value}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : section.layout === 'table' ? (
                <table className={`medical-report-table ${section.title === 'REFERENCE RANGES' ? 'medical-report-table-reference' : ''}`}>
                  <tbody>
                    {section.data && Array.isArray(section.data) && section.data.map((row, rowIndex) => (
                      <tr key={rowIndex} className="medical-report-table-row">
                        {row && Array.isArray(row) && row.map((cell, cellIndex) => (
                          <td key={cellIndex} className={`medical-report-table-cell ${cell.bold ? 'font-semibold' : ''}`}>
                            {cell.value}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : section.layout === 'single' ? (
                // Single layout for text content like Comments/Diagnosis
                <div style={{display: 'flex', flexDirection: 'column', gap: '0.25rem'}}>
                  <div className="medical-report-section-row">
                    <span className="medical-report-section-value" style={{whiteSpace: 'pre-wrap', fontSize: '14px', lineHeight: '1.5'}}>
                      {section.data || ''}
                    </span>
                  </div>
                </div>
              ) : (
                // Default single column layout
                <div style={{display: 'flex', flexDirection: 'column', gap: '0.25rem'}}>
                  {section.data && Array.isArray(section.data) && section.data.map((item, itemIndex) => (
                    <div key={itemIndex} className="medical-report-section-row">
                      <span className="medical-report-section-label w-40">{item.label}</span>
                      <span className="medical-report-section-value">: {item.value}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}

        {/* Impression */}
        {impression && (
          <div className="medical-report-impression">
            <div className="medical-report-impression-content">
              <div className="medical-report-impression-row">
                <span className="medical-report-impression-label">Impression</span>
                <span className="medical-report-impression-value">: {impression}</span>
              </div>
            </div>
          </div>
        )}

        {/* Advice */}
        {comments && (
          <div className="medical-report-impression">
            <div className="medical-report-impression-content">
              <div className="medical-report-impression-row">
                <span className="medical-report-impression-label">Comments</span>
                <span className="medical-report-impression-value">: {comments}</span>
              </div>
            </div>
          </div>
        )}

        {/* Reference Values Table */}
        {referenceValues && referenceValues.length > 0 && (
          <div className="medical-report-reference-table">
            <div className="medical-report-reference-header">
              <h3 className="medical-report-reference-title">
                WHO reference values 2021 6th Edition
              </h3>
            </div>
            <div className="medical-report-reference-content">
              <table className="medical-report-table">
                <tbody>
                  {referenceValues.map((row, rowIndex) => (
                    <tr key={rowIndex} className="medical-report-table-row">
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className={`medical-report-table-cell ${cell.bold ? 'font-semibold' : ''}`}>
                          {cell.value}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Androtech and Consultant Labels */}
        <div style={{marginTop: '20px', marginBottom:'10px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', fontSize: '14px', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"}}>
          <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
            {/* Androtech Label */}
            <div style={{display: 'flex', alignItems: 'center'}}>
              <strong style={{marginRight: '210px', minWidth: '100px', fontSize: '14px', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"}}>Androtech: {defaultPatientData.androtechName}</strong>
            </div>

            {/* Consultant Label */}
            <div style={{display: 'flex', alignItems: 'center'}}>
              <strong style={{marginRight: '210px', minWidth: '100px', fontSize: '14px', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"}}>Consultant: {defaultPatientData.consultantName}</strong>
            </div>
          </div>
        </div>

        {/* Footer */}
        {footerText && (
          <div className="medical-report-footer">
            <p>{footerText}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MedicalReportTemplate;
